import React from 'react'
import { Route, Switch } from 'react-router'
import {Flex} from '/app/src/component'

import FAQ from './FAQ'
import Customization from './Customization'
import Formular from './Formular'
import OfflineSettings from './OfflineSettings'
import ExchangeSystem from './Exchange'
import AutoMessage from './AutoMessage'
import AutoResponseMainPanel from './AutoResponse'
import Rating from './Rating'
import {withCustomization} from '/app/src/hoc'
import WithPaymentPermission from '/app/src/hoc/withPaymentPermission'


class ClientChatSettings extends React.Component {

    render(){
        const MainpanelExchangeRoute= WithPaymentPermission('exchange')(Route)

        return (
            <Flex height='100%' width='100%'>
                <Switch>
                    <Route path='/clientChat/customization' component={withCustomization(Customization)}/>
                    <Route path='/clientChat/formular' component={withCustomization(Formular)}/>
                    <Route path='/clientChat/offlinesettings' component={withCustomization(OfflineSettings)}/>
                    <Route path='/clientChat/faq' component={withCustomization(FAQ)}/>
                    <Route path='/clientChat/autoMessage' component={withCustomization(AutoMessage)}/>
                    <Route path='/clientChat/autoResponse' component={withCustomization(AutoResponseMainPanel)}/>
                    <Route path='/clientChat/rating' component={withCustomization(Rating)}/>

                    <MainpanelExchangeRoute path='/clientChat/exchange' component={withCustomization(ExchangeSystem)}/>
                </Switch>
            </Flex>
        )
    }
}
export default ClientChatSettings;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/index.js